import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import {
  setNotificationsData,
  setUnreadNotificationsCount,
  setShowNotification,
  readNotificationsData,
  unreadNotificationsData,
  setNotificationsStatusesData,
} from "../reducers/notification";

export {
  setNotificationsData,
  setUnreadNotificationsCount,
  setShowNotification,
  readNotificationsData,
  unreadNotificationsData,
  setNotificationsStatusesData,
};

export async function getNotifications(newCountRequired = 4, oldCountRequired = 4) {
  const data = {
    value: {
      source: "header",
      newNotificationsFilter: {
        notificationType: ["NOTIFICATION_UNREAD"],
        requiresCounts: false,
        sortBy: { createdDate: -1 },
        limit: newCountRequired,
        offset: 0,
      },
      previousNotificationsFilter: {
        notificationType: ["NOTIFICATION_READ"],
        requiresCounts: false,
        sortBy: { createdDate: -1 },
        limit: oldCountRequired,
        offset: 0,
      },
    },
  };

  try {
    const response = await axiosWrapper.post(`${getBackendUrl()}/notifications/getNotifications`, data);
    return response.data;
  } catch (err) {
    console.log(err);
  }
}

export function getNotificationsCount(filterType: any) {
  const data = {
    filter: filterType,
  };
  return async (dispatch: any) => {
    try {
      const response = await axiosWrapper.post(`${getBackendUrl()}/notifications/getNotificationsCount`, data);

      if (response.data.status) {
        dispatch(setUnreadNotificationsCount(response.data.data));
      }
    } catch (err) {
      console.log(err);
    }
  };
}

export async function readNotification(idsArr: any) {
  const data = {
    ids: idsArr,
  };

  try {
    const response = await axiosWrapper.post(`${getBackendUrl()}/notifications/dismissNotification`, data);

    return response.data.status;
  } catch (err) {
    console.log(err);
  }
}

export async function unreadNotification(idsArr: any) {
  const data = {
    ids: idsArr,
  };

  try {
    const response = await axiosWrapper.post(`${getBackendUrl()}/notifications/unreadNotification`, data);

    return response.data.status;
  } catch (err) {
    console.log(err);
  }
}
